import React from "react";
import { IHeadlineBlock } from "@montana/models/generated/cms.interface";
import { RichText } from "@montana/shared/rich-text";
import { isBrowser } from "@montana/helpers/browser.helper";
import { Appear } from "@montana/shared/appear/appear.component";
import { SoftHyphens } from "@montana/shared/soft-hyphens";

export const M00HeadlineAndTextBlock: React.FC<IHeadlineBlock> = React.memo((props: IHeadlineBlock): JSX.Element | null => {
    const {
        headlineText,
        headlineTag,
        text,
    } = props;

    if (!headlineText && !text) {
        return null;
    }

    let headingTag = headlineTag ? headlineTag.toLowerCase() : '';
    let h1Exists = false;
    if (headingTag === "h1") {
        h1Exists = isBrowser && !!document.querySelector("h1"); // Default to h2 SSR
        headingTag = h1Exists ? "h2" : "h1";
    }

    const classNames = [
        "headline-and-text-block__headline",
        h1Exists ? "display-4" : "display-3",
    ];

    return (
        <section className="headline-and-text-block">
            <div className="headline-and-text-block__row row">
                {headingTag && headlineText && (
                    <div className="headline-and-text-block__col-headline col">
                        <div className="row">
                            <Appear className="headline-and-text-block__col-appear col">
                                <SoftHyphens tagName={headingTag} className={classNames.join(' ')} text={headlineText}/>
                            </Appear>
                        </div>
                    </div>
                )}
                {text && (
                    <RichText className="headline-and-text-block__text col" text={text} />
                )}
            </div>
        </section>
    );
});
